import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import bgShape from './bg-shape.svg';

import './carmax-calculator-header.scss';

export const CarmaxCalculatorHeader = () => (
  <header className="carmax-calculator-header pos-r mb-2">
    <img src={bgShape} alt="" className="bg-shape w-100 pos-a" />
    <Container className="header-content">
      <Row>
        <Col xs={12} lg={8}>
          <div className="px-0_75 px-lg-0">
            <h1 className="title text-white fw-bold mb-0_75 text-shadow-contrast">Newer Car, Same Payment?</h1>
            <p className="subtitle text-white fw-medium text-shadow-contrast mb-0">
              Your car may be worth more than you owe. Use your equity toward a newer car for the same monthly payment.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  </header>
);
